<template>
	<div>
		<div class="container-fluid">
			<div class="page-header">
				<Breadcrumbs main="sales" title="Abondaned cart" />
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="card pt-3 pb-3" v-for="item in listData" :key="item.host">

						<TableAbondanedCart :site="item.host"></TableAbondanedCart>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from '@/utils/firestore-shim';
import TableAbondanedCart from "./TableAbondanedCart.vue";
import Cookies from 'js-cookie';
export default {
	components: { TableAbondanedCart },
	data() {
		return {
			listData: []
		};
	},
	async mounted() {
		this.listData = await this.getStoresData();
	},
	methods: {
		async getStoresData() {
			let listData = [];
			var ProductRef = await firebase.firestore().collection("Sites")
				.where("host", "==", this.getStore())
				.get()
				.then((querySnapshot) => {
					querySnapshot.forEach((doc) => {
						listData.push(
							doc.data()
						);
					});
				});
			return listData;

		},
		getStore() {
			const host = Cookies.get('hostCookie');
			if (host) {
				return host;
			} else {
				this.$router.push('/dashboard/default');
			}
		},
	}
}
</script>

<style lang="scss" scoped>
table.text-center * {
	text-align: center;
}
</style>